// extracted by mini-css-extract-plugin
export var closeButton = "_pg-2";
export var closeButtonIcon = "_pg-3";
export var lightboxContent = "_pg-1";
export var lightboxOverlay = "_pg-0";